import { useShoppingCartStore } from "@/store/shoppingCart";
import { shoppingCartRepository } from "@/repositories/shoppingCartRepository";
import { UpdateCartRequestPayload } from "@/models/request/cart/UpdateCartRequestPayload";
import { DeleteCartItemRequestPayload } from "../models/request/cart/DeleteCartItemRequestPayload";
import { CreateCartResponse } from "@/models/response/cart/CreateCartResponse";
import { FetchCartResponse } from "@/models/response/cart/FetchCartResponse";

export function shoppingCartService() {
  const store = useShoppingCartStore();

  async function fetchCart() {
    const cartId = store.shoppingCartId;
    const { data, error } = await shoppingCartRepository.fetchCart(cartId);

    // TODO: Only certain errors should reset and create new cart?
    if (error.value) {
      if (
        error.value.status === 404 ||
        error.value.status === 401 ||
        error.value.status === 403
      ) {
        // If cart is not found or the user does not have the rights to access the cart, reset the cart and create a new one
        resetCart();
        await createCart();
      }

      throw error.value;
    }
    const response = new FetchCartResponse(data.value.data);

    store.initialize(response);
  }

  async function createCart() {
    const { data, error } = await shoppingCartRepository.createCart();

    if (error.value) {
      throw error.value;
    }

    const response = new CreateCartResponse(data.value.data);

    store.createCart(response);
  }

  async function fetchOrCreateShoppingCart() {
    if (store.shoppingCartId) {
      await fetchCart();
    } else {
      await createCart();
    }
  }

  /**
   *
   * @param {Object} updateCartData
   */
  async function updateCart(updateCartData) {
    const cartId = store.shoppingCartId;

    const payload = new UpdateCartRequestPayload(updateCartData);

    const { data, error } = await shoppingCartRepository.updateCart({
      cartId,
      payload: payload.toJSON(),
    });

    // TODO: Add check to create a cart if 404 for example
    if (error.value) {
      throw error.value;
    }

    if (data.value.data.exceedsStock) {
      const response = new FetchCartResponse(data.value.data);
      store.initialize(response);
    } else {
      store.updateCart(payload.sku, payload.quantity);
    }
    
    return data.value;
  }
  /**
   * 
   * @param {Object} deleteCartItemData 
   */
  async function deleteCartItem(deleteCartItemData) {
    const cartId = store.shoppingCartId;

    const payload = new DeleteCartItemRequestPayload(deleteCartItemData);

    const { data, error } = await shoppingCartRepository.deleteCartItem({
      cartId,
      payload: payload.toJSON(),
    });

    if (error.value) {
      throw error.value;
    }

    store.deleteCartItem(payload.sku);
  }

  async function clearCart() {
    const cartId = store.shoppingCartId;
    if (cartId) {
      await shoppingCartRepository.clearCart(cartId);
    }
    store.clear();
  }

  function resetCart() {
    store.clear();
  }

  return {
    fetchCart,
    createCart,
    fetchOrCreateShoppingCart,
    updateCart,
    resetCart,
    clearCart,
    deleteCartItem,
  };
}
